import { useNavigate } from 'react-router-dom';

interface BackWithCustomTextProps {
  statement?: string;
  clickLabel?: string;
}

const BackWithCustomText = (props: BackWithCustomTextProps) => {
  const { statement = '', clickLabel = '< Back' } = props;

  const navigate = useNavigate();

  const navigateBack = () => navigate(-1);

  return (
    <div
      className="mt-2 cursor-pointer text-sm text-grey "
      role="presentation"
      onClick={navigateBack}
    >
      <span className="text-primary">{clickLabel} </span>
      {!!statement && <span>{statement}</span>}
    </div>
  );
};

export default BackWithCustomText;
